export const GLOBAL_FAVICON = "../../public/favicon.ico";
export const GLOBAL_PARTNER = "Velove";
